import React, { useEffect, useState } from 'react';
import { Routes, BrowserRouter as Router, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import logo from './logo.svg';
import './App.scss';
// import './index.css';
import Footer from './Footer';
import Navbar from './Navbar'; 
import SideMenu from './SideMenu.js';
import AiWallet from './billing/AiWallet';
import './scss/font.scss';
import EvaluationTec from './autogenAca/EvaluationTec';
import GradeView from './autogenAca/GradeView';
import Login from './login/BasicLogin';
import SignUp from './login/SignUp';
import CreatPw from './login/CreatePw';
import UpdatePw from './login/UpdatePw';
import UpdateApp from './login/UpdateApp';
import HomeApp from './page_home/HomeApp';
import Book from './page_book/Book';
import Digital from './page_digital/Digital';
import Exam from './page_exam/Exam';
import CourseReg from './page_courseReg/CourseReg';
import CourseRegTec from './page_courseRegTec/CourseRegTec';
import BasicSetting from './page_basicSetting/BasicSetting';
import Lms from './page_lms/Lms';
import LmsTec from './page_lmsTec/LmsTec';
import LmsLearningReport from './page_lmsReport/LmsLearningReport';

import Combobox from './comm/Combobox';
import DrawMenu from './drawSvg/DrawMenu';

import Download_newWindow from './page_lms/Download_newWindow';
import LmsTecResultApp from './page_lmsTec_result/LmsTecResultApp';
import FindPw from './login/FindPw';
import FindPw_update from './login/FindPw_update';
import FindId from './login/FindId';
import DeleteId from './login/DeleteId';
import BoardDetail from './page_board_comm/BoardDetail';
import FileDownloadWebpage from './page_lmsTec/FileDownloadWebpage';
import MunMaual from './page_munMaual/MunMaual';
import SaveTestApp from './page_saveTest/SaveTestApp';
import SaveTestApp_new from './page_saveTest_new/SaveTestApp_new';


import MainPage from './page_home/MainPage';
import Board from './page_board/Board';
import StoreBook from './page_storeBook/StoreBook';
import ChatRoomListPage from './page_firebase/ChatRoomListPage';
import ChatWindowPage from './page_firebase/ChatWindowPage';
import BrochurePdfModal from './page_home/BrochurePdfModal';
import { useBrochureModal } from './page_home/brochureSuppression';


import { useSelector, useDispatch, Provider } from 'react-redux';
import {Container} from './scss/theme';
import { setVersion, setIsLoginPage } from './reduxToolkit/redux';
// import DirectMessageTest from './page_firebase/DirectMessageTest.js';
import DirectMessageApp from './page_firebase/directMessage/DirectMessageApp.js';
import IframePage from './page_iframe/IframePage';
import Home_tailer from './src_tailer/pages/Home/Home.jsx';
import AdminLayout from './src_tailer/components/myroom/AdminLayout.jsx';
import Ad_login from './src_tailer/components/admin/Ad_login.js';
import OpenSatus_users from './src_tailer/components/admin/openSatus_users/OpenSatus_users.js';
import LoginHistory from './src_tailer/components/admin/loginHistory/LoginHistory.js';
import SmsSend from './src_tailer/components/admin/sms/SmsSend.js';
import { tailerStore } from './src_tailer/reduxToolkit/store';
import TailerSignUp from './tailer_login/SignUp';





function App() {

  const [isTailerModalOpen, setIsTailerModalOpen] = useState(false);
  const [isTailerAdminMode, setIsTailerAdminMode] = useState(false);
  const [tailerPrevPath, setTailerPrevPath] = useState('/');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로를 얻기 위해 useLocation 훅 사용
  const { isBrochureModalOpen, openBrochureModal, closeBrochureModal, hideBrochureForToday } = useBrochureModal(location.pathname);
  const isLoggedIn = useSelector(state => state.reduxStore.isLoggedIn);
  const userInfo = useSelector(state => state.reduxStore.userInfo);
  const isTailerAdminButtonVisible = (userInfo?.id || userInfo?.userId || '') === 'kuku1234';
  const isHomeInnerScrollRoute = ['/', '/homeApp', '/main'].includes(location.pathname);
  
  // window.AppVersion_ios = (version) => {
  //   alert(version);
  //   if (version){
    
  //     dispatch(setVersion(version));
  //   }
  // // };
  const version = localStorage.getItem('AppVersion');
  const deviceInfo = localStorage.getItem('DeviceInfo');
  const fcmToken = localStorage.getItem('FcmToken');

  useEffect(() => {
    if (version){
          dispatch(setVersion(version));
    }
  }, [version]);

  
 useEffect(() => {
  if (deviceInfo) {
    try {
      const obj = JSON.parse(deviceInfo);
      if (obj?.vendorID) {
        // alert(obj.vendorID);
      } else {
        console.warn("venderID가 존재하지 않습니다.", obj);
      }
    } catch (error) {
      console.error("JSON 파싱 오류:", error);
    }
  }
}, [deviceInfo]);

useEffect(() => {
  if (fcmToken){
      
  }
}, [fcmToken]);

 

  
  // window.AppVersion = (version) => {
  //   if (version){
  //     dispatch(setVersion(version));
  //   }
  // };

  
  //-------------------------------------------------------------최신 업데이트
  useEffect(() => {//잘 안 되면 build 폴더를 지우고 추가해봐(앞으로 빼서 그런지 되긴 한다.)

    const currentVersion = localStorage.getItem('updateVersion');
    const newVersion = '1.0.35';

    if (currentVersion !== newVersion) {
      localStorage.setItem('updateVersion', newVersion); 
      window.location.reload(true); // 강제 새로고침, 사파리는 어떤지 확인 필요
    }
  }, []);

  useEffect(() => {
    // 현재 경로가 로그인 관련 경로인지 확인
    if (location.pathname === '/' || location.pathname === '/login') {
      dispatch(setIsLoginPage(true));
    } else {
      dispatch(setIsLoginPage(false));
    }
  }, [location.pathname, dispatch]);

    
  const hideLayoutPaths = ['/fileDownloadWebpage']; // 레이아웃 숨길 경로 리스트
  const isLayoutHidden = hideLayoutPaths.includes(location.pathname);

  const openTailerModal = () => {
    setTailerPrevPath(`${location.pathname}${location.search}`);
    setIsTailerAdminMode(false);
    setIsTailerModalOpen(true);
  };

  const closeTailerModal = () => {
    if (location.pathname.startsWith('/admin')) {
      navigate(tailerPrevPath || '/');
    }
    setIsTailerModalOpen(false);
    setIsTailerAdminMode(false);
  };

  useEffect(() => {
    if (!isTailerModalOpen && !isBrochureModalOpen) return;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        if (isTailerModalOpen) {
          closeTailerModal();
          return;
        }
        closeBrochureModal();
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isTailerModalOpen, isBrochureModalOpen, closeBrochureModal]);

  useEffect(() => {
    if (isTailerModalOpen || isBrochureModalOpen) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      return () => {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      };
    }

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    return undefined;
  }, [isTailerModalOpen, isBrochureModalOpen]);

  const TailerAdminScreen = () => {
    return (
      <Routes>
        <Route path="/admin/login" element={<Ad_login disableNavigate={false} />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="myroom" element={<Navigate to="/admin/users" replace />} />
          <Route path="users" element={<OpenSatus_users />} />
          <Route path="login-history" element={<LoginHistory />} />
          <Route path="sms" element={<SmsSend />} />
        </Route>
        <Route path="*" element={<Ad_login disableNavigate={false} />} />
      </Routes>
    );
  };


  //==============================================
  return (
    <div className={`App ${isTailerModalOpen ? 'tailer-open' : ''} ${isHomeInnerScrollRoute ? 'home-inner-scroll' : ''}`}>

      <Navbar onOpenBrochureModal={openBrochureModal} />

      <div className="app-layout">
  
          {isLoggedIn && <SideMenu />}
          <div className="main-content">
          <Container $allowPageScroll={location.pathname === '/home_tailer'}>
            <Routes>
            <Route path="/evaluationTec" element={<EvaluationTec />} />
              <Route path="/gradeView" element={<GradeView />} />

              <Route path="/creatpw" element={<CreatPw />} />
              <Route path="/updatepw" element={<UpdatePw />} />
              <Route path="/updateapp" element={<UpdateApp />} />

              {/* <Route path="/" element={<MainPage />} /> */}
              <Route path="/" element={<HomeApp onOpenBrochure={openBrochureModal} />} />
          
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />

              <Route path="/homeApp" element={<HomeApp onOpenBrochure={openBrochureModal} />} />
              <Route path="/digital" element={<Digital />} />
              <Route path="/book" element={<Book />} />
              <Route path="/exam" element={<Exam />} />
              <Route path="/courseRegTec" element={<CourseRegTec />} />
              <Route path="/courseReg" element={<CourseReg />} />
              <Route path="/BasicSetting" element={<BasicSetting />} />
              <Route path="/LmsTec" element={<LmsTec />} />
              <Route path="/ai-wallet" element={<AiWallet />} />
              <Route path="/Lms" element={<Lms />} />
              <Route path="/LmsReport" element={<LmsLearningReport />} />
              <Route path="/LmsTecResultApp" element={<LmsTecResultApp />} />

              <Route path="/combobox" element={<Combobox />} />
              <Route path="/drawMenu" element={<DrawMenu />} />

              <Route path="/downloadNewWindow" element={<Download_newWindow />} />

              <Route path="/findPw" element={<FindPw />} />
              <Route path="/findPwUpdate" element={<FindPw_update />} />
              <Route path="/findId" element={<FindId />} />
              <Route path="/deleteId" element={<DeleteId />} />
              <Route path="/boardDetail" element={<BoardDetail />} />
              <Route path="/fileDownloadWebpage" element={<FileDownloadWebpage />} />
              <Route path="/munMaual" element={<MunMaual />} />
              <Route path="/saveTestApp" element={<SaveTestApp />} />
              <Route path="/saveTestApp_new" element={<SaveTestApp_new />} />
              <Route path="/main" element={<MainPage onOpenBrochure={openBrochureModal} />} />
              <Route path="/board" element={<Board />} />
              <Route path="/storeBook" element={<StoreBook />} />
            
              <Route path="/chatRoomListPage" element={<ChatRoomListPage />} />
              {/* <Route path="/chat/:chatroomId" element={<ChatWindowPage />} /> */}
              <Route path="/chatWindowPage/:chatroomId" element={<ChatWindowPage />} />
              {/* <Route path="/directMessageTest" element={<DirectMessageTest />} /> */}
              <Route path="/directMessageApp" element={<DirectMessageApp />} />
              {/* <Route path="/iframe" element={<IframePage />} /> */}
              <Route path="/home_tailer" element={<Home_tailer disableHomePageRoutesApi={true} />} />
              <Route path="/tailer-signup" element={<TailerSignUp />} />

            </Routes>
          </Container>
          </div>

      </div>

      {isBrochureModalOpen && (
        <div className="brochure-global-modal">
          <BrochurePdfModal onClose={closeBrochureModal} onHideForToday={hideBrochureForToday} />
        </div>
      )}

      {isTailerModalOpen && (
        <div className="tailer-modal" role="dialog" aria-modal="true" aria-label="AI 매쓰테일러">
          {isTailerAdminButtonVisible && (
            <button
              className="tailer-modal__admin"
              onClick={() => {
                if (!isTailerAdminMode) {
                  setIsTailerAdminMode(true);
                  navigate('/admin/login');
                  return;
                }

                if (location.pathname.startsWith('/admin')) {
                  navigate(tailerPrevPath || '/');
                }
                setIsTailerAdminMode(false);
              }}
            >
              {isTailerAdminMode ? '홈' : '관리자'}
            </button>
          )}
          <button className="tailer-modal__close" onClick={closeTailerModal}>
            닫기
          </button>
          <div className={`tailer-modal__content ${isTailerAdminMode ? 'tailer-modal__content--admin' : ''}`}>
            <Provider store={tailerStore}>
              {isTailerAdminMode ? <TailerAdminScreen /> : <Home_tailer disableHomePageRoutesApi={true} />}
            </Provider>
          </div>
        </div>
      )}



      {/* <Navbar /> */}
      {/* <div className="box_routes"> */}
        {/* <Container> */}
            {/* <Routes> */}
    
              {/* <Route path="/evaluationTec" element={<EvaluationTec />} />
              <Route path="/gradeView" element={<GradeView />} />

              <Route path="/creatpw" element={<CreatPw />} />
              <Route path="/updatepw" element={<UpdatePw />} />
              <Route path="/updateapp" element={<UpdateApp />} />

              <Route path="/" element={<HomeApp />} />
          
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />

              <Route path="/homeApp" element={<HomeApp />} />
              <Route path="/digital" element={<Digital />} />
              <Route path="/book" element={<Book />} />
              <Route path="/exam" element={<Exam />} />
              <Route path="/courseRegTec" element={<CourseRegTec />} />
              <Route path="/courseReg" element={<CourseReg />} />
              <Route path="/BasicSetting" element={<BasicSetting />} />
              <Route path="/LmsTec" element={<LmsTec />} />
              <Route path="/Lms" element={<Lms />} />
              <Route path="/LmsTecResultApp" element={<LmsTecResultApp />} />

              <Route path="/combobox" element={<Combobox />} />
              <Route path="/drawMenu" element={<DrawMenu />} />

              <Route path="/downloadNewWindow" element={<Download_newWindow />} />

              <Route path="/findPw" element={<FindPw />} />
              <Route path="/findPwUpdate" element={<FindPw_update />} />
              <Route path="/findId" element={<FindId />} />
              <Route path="/deleteId" element={<DeleteId />} />
              <Route path="/boardDetail" element={<BoardDetail />} />
              <Route path="/fileDownloadWebpage" element={<FileDownloadWebpage />} /> */}
            {/* </Routes> */}
        {/* </Container> */}

      {/* </div> */}
      
    </div>
  );
}

export default App;
